import React, { useMemo, useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';

const rawColumns = [
  { field: 'catalogChannelId', headerName: 'Catalog Channel ID', width: 180 },
  { field: 'channelSkuId', headerName: 'Channel SKU ID', width: 160 },
  { field: 'itemName', headerName: 'Item Name', width: 200 },
  { field: 'brand', headerName: 'Brand', width: 140 },
  { field: 'color', headerName: 'Color', width: 120 },
  { field: 'size', headerName: 'Size', width: 100 },
  { field: 'category', headerName: 'Category', width: 140 },
  { field: 'subCategory', headerName: 'Sub Category', width: 160 },
  { field: 'shipmentMethod', headerName: 'Shipment Method', width: 160 },
  { field: 'shippingSpeed', headerName: 'Shipping Speed', width: 140 },
];

export default function CatalogLedgerList({ onCreateClick, catalogItems, pagination, onPageChange, onView, onEdit }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);

  const page = (pagination?.currentPage || 1) - 1;
  const pageSize = pagination?.limit || 10;
  const totalCount = pagination?.totalRecords || 0;

  useEffect(() => {
    if (Array.isArray(catalogItems) && catalogItems.length) {
      const formatted = catalogItems.map(item => ({
        id: item._id,
        catalogChannelId: item.catalogChannelId,
        channelSkuId: item.channelSkuId,
        itemName: item.itemName,
        brand: item.brand,
        color: item.color,
        size: item.size,
        category: item.category,
        subCategory: item.subCategory,
        shipmentMethod: item.shipmentMethod,
        shippingSpeed: item.shippingSpeed,
        __original: item
      }));
      setTableRows(formatted);
    } else {
      setTableRows([]);
    }
  }, [catalogItems]);

  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
        aria-label="row actions"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };

  const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );

  return (
    <>
      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}
        height={520}
        rowsPerPageOptions={[10, 25, 50, 100]}
        exportImportPath="Catalog"
        forItems
        showCreateButton={true}
        createButtonText="Create New"
        createButtonIcon="bi-plus-lg"
        onCreateClick={onCreateClick}
        createButtonVariant="contained"
        createButtonColor="primary"
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => onPageChange(newPage + 1, pageSize)}
        onPageSizeChange={(newSize) => onPageChange(1, newSize)}
      />

      <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
        <MenuItem onClick={() => { onView(menuRow.__original); handleCloseMenu(); }}>
          <i className="bi bi-eye me-2" /> View
        </MenuItem>
        <MenuItem onClick={() => { onEdit(menuRow.__original); handleCloseMenu(); }}>
          <i className="bi bi-pencil me-2" /> Edit
        </MenuItem>
      </Menu>
    </>
  );
}
